import { Sidebar } from "primereact/sidebar";
import "./pay-contract.scss";
import { useLocation, useNavigate } from "react-router-dom";
import NewPayment from "@domain/payment/new-payment/new-payment";

/* eslint-disable-next-line */
export interface PayContractProps {
  isBulk?: boolean;
}

export function PayContract({}: PayContractProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { balance, isBulk } = location.state || {};

  return (
    <div id="PayContract" className="pay-contract">
      <Sidebar
        visible={true}
        onHide={() => navigate("../billing")}
        className="w-full md:w-[500px]"
      >
        <NewPayment isBulk={isBulk} balance={balance} />
      </Sidebar>
    </div>
  );
}

export default PayContract;
